import React from 'react'
import { object, array, string } from 'prop-types'

class GetCachedPrice extends React.Component {
  // Tech debt #181
  getProduct () {
    const { pageData: { productClass } } = this.props
    switch (productClass.toUpperCase()) {
      case 'CP':
        return {
          path: 'parking/',
          type: 'CP'
        }
      case 'HCP':
        return {
          path: 'hotels/',
          type: 'HCP'
        }
      case 'HO':
        return {
          path: 'hotels/',
          type: 'HO'
        }
      case 'LO':
        return {
          path: 'lounges/',
          type: 'LO'
        }
      case 'CH':
        return {
          path: 'carhire/',
          type: 'CH'
        }
    }

    return false
  }

  getPriceFromFeed (product) {
    const code = this.props.functionParams[0]
    if (code.length >= 3) {
      try {
        const { prices } = require('../../../../../config/exports/buildTimeOnly/prices/' + product.path + code + '.json')
        const type = this.getPriceType(product.type, code)
        if (type && prices && prices[ type ]) {
          return prices[ type ]
        } else if (prices && prices.lowestPrice) {
          return prices.lowestPrice
        } else if (prices && prices.cheapestCarPricePerDay) {
          return prices.cheapestCarPricePerDay
        }
        return false
      } catch (e) {
        return false
      }
    }
  }

  getPriceFromParams (product) {
    if (product.type === 'CP' && this.props.functionParams[3]) {
      return this.props.functionParams[3]
    } else if ((product.type === 'HCP' || product.type === 'HO') && this.props.functionParams[2]) {
      return this.props.functionParams[2]
    }
    return false
  }

  getPriceType (productType, code) {
    const { functionParams } = this.props
    const isLocation = code.length === 3
    if (productType === 'CH') return false
    if (productType === 'CP') {
      let per = 'per_week'
      let type = ''
      if (functionParams[1] === 'perday') per = 'per_day'
      if (!isLocation || !functionParams[2]) return per
      switch (functionParams[2]) {
        case 'onairport':
          type = 'on_airport'
          break
        case 'offairport':
          type = 'off_airport'
          break
        case 'meetandgreet':
          type = 'meet_and_greet'
          break
      }
      if (type && per === 'per_week') return type
      return per + '_' + type
    }

    let priceKey

    if (isLocation) {
      priceKey = 'lowestPrice'
    } else {
      priceKey = (productType === 'HO') ? 'lowestDays0' : 'lowestDays8'
    }

    if (isLocation || productType === 'HCP') {
      switch (functionParams[1]) {
        case '8':
          priceKey = 'lowestDays8'
          break
        case '15':
          priceKey = 'lowestDays15'
          break
      }
    }

    return priceKey
  }

  render () {
    const { id, functionParams, settings: { priceFormat, decimalNotation } } = this.props
    const product = this.getProduct()
    const code = functionParams[0]
    const type = (product) ? this.getPriceType(product.type, code) : false
    let price = (product) ? this.getPriceFromFeed(product) : false
    if (!price && product) {
      price = this.getPriceFromParams(product)
    }
    if (price) price = parseFloat(price).toFixed(2).replace('.', decimalNotation)
    return (
      <span id={id} data-type={type} className='priceSmall'>{ product && price && priceFormat + price }</span>
    )
  }
}

GetCachedPrice.propTypes = {
  id: string.isRequired,
  settings: object,
  functionParams: array,
  pageData: object
}

export default GetCachedPrice



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/pricing/getCachedPrice.jsx